import { ITrimEditorManagerBase } from '../trim-editor.manager';
import { TrimImageEditManager } from '../image-edit/trim.image-edit.manager';
import { TrimUiManager } from '../ui/trim.ui.manager';
import { TrimPanZoomManager } from '../pan-zoom/trim.pan-zoom.manager';
import { Pos } from '../../../models/pos';

export class TrimPosManager implements ITrimEditorManagerBase {

  // - mode -
  private isDev = true;
  // - manager -
  private uiManager!: TrimUiManager;
  private panZoomManager!: TrimPanZoomManager;
  // - canvas -
  private canvas!: HTMLCanvasElement;

  di(
    imageEditManager: TrimImageEditManager,
    uiManager: TrimUiManager,
    panZoomManager: TrimPanZoomManager,
  ): void {
    this.uiManager = uiManager;
    this.panZoomManager = panZoomManager;
    this.canvas = imageEditManager.getCanvasEle();
  }

  initialize(): void {
  }

  destroy(): void {
  }

  browserToCanvas(pos: Pos) {
    this.debug({
      method: 'browserToCanvas',
      originalPos: pos,
    });
    return pos;
  }

  canvasToBrowser(pos: Pos) {
    const scale = this.panZoomManager.scale;
    const canvasPos: Pos = {
      x: this.canvas.getBoundingClientRect().left,
      y: this.canvas.getBoundingClientRect().top,
    };
    const solvedPos: Pos = {
      x: canvasPos.x + (pos.x + TrimImageEditManager.STAGE_CONTAINER_X) * scale,
      y: canvasPos.y + (pos.y + TrimImageEditManager.STAGE_CONTAINER_Y) * scale,
    };
    // this.debug({
    //   method: 'canvasToBrowser',
    //   scale,
    //   canvasPos,
    //   originalPos: pos,
    // });
    return { ...solvedPos, scale };
  }

  private debug(props: {
    method: string
    scale?: number,
    canvasPos?: Pos,
    originalPos?: Pos,
  }) {
    if (!this.isDev) {
      return;
    }
    const { originalPos, method, scale, canvasPos } = props;
    console.group('TrimPosManager');
    console.log('method : ', method);
    console.log('scale : ', scale);
    console.log('canvasPos : ', canvasPos);
    console.log('pos : ', originalPos);
    console.log('TrimImageEditManager.STAGE_CONTAINER_ : ', TrimImageEditManager.STAGE_CONTAINER_X, TrimImageEditManager.STAGE_CONTAINER_Y);
    console.groupEnd();
  }
}
